import React, { Component } from 'react';
import * as qs from 'query-string';
import Home from './Home';
import Product from './Product';
import { getProduct } from '../modules/helper';
import '../App.css';

class Landing extends Component {
  constructor(props) {
    super(props);
    let initConfig;
    try {
      var url_string = window.location.href; //window.location.href
      var url = new URL(url_string);
      var c = url.searchParams.get('configuration')
        ? url.searchParams.get('configuration').replace('ANDPLACEHOLDER', '&')
        : '{}';
      c.replace('6', '6\\');
      initConfig = JSON.parse(c);
    } catch (e) {
      initConfig = null;
    }

    this.state = {
      size: 6,
      api: null,
      loaded: false,
      path: this.props.match.params.product
        ? this.props.match.params.product
        : this.props.match.params.type
          ? this.props.match.params.type
          : 'configure',
      initConfig,
    };
  }
  setAppState = newState => {
    this.setState(newState);
  };

  componentWillReceiveProps(nextProps) {
    let pathname = nextProps.location.pathname.replace(/\/$/, '');
    pathname = pathname.substr(pathname.lastIndexOf('/') + 1);
    this.setState({ path: pathname, loaded: false });
  }

  render() {
    const { api, loaded, path, initConfig, size } = this.state;

    const product = getProduct(path);
    const hasSubProd =
      product.products.sceneId && product.products.publishedHash;

    if (product !== 'none') {
      return (
        <div className="app-root">
          {hasSubProd ? (
            <Product
              api={api}
              loaded={loaded}
              product={product.products}
              setAppState={this.setAppState}
              size={size}
              initConfig={initConfig}
            />
          ) : (
            <div className="app-root">
              <Home
                {...this.props}
                path={path}
                product={product.products}
                name={product.name}
                setAppState={this.setAppState}
                type={path}
              />
            </div>
          )}
        </div>
      );
    } else {
      return <div>no match</div>;
    }
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/pages/Landing.js